module.exports = __webpack_public_path__ + "static/media/Architecture_06.c7cf50f9.jpg";